import { useState, useRef, useEffect } from "react";
import FiltersButton from "../FiltersButton";
import CapacityFilter from "../CapacityFilter";
import { useDispatch, useSelector } from "react-redux";
import { selectFilters } from "store/filters/selectors";
import { SearchPeopleIcon } from "assets/icons";

import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const CapacityFilterButton = () => {
  const dropdownRef = useRef(null);
  const [t] = useTranslation("global");
  const filters = useSelector(selectFilters);
  const [showCapacityDropdown, setShowCapacityDropdown] = useState(false);

  // Function to toggle dropdown visibility
  const toggleShowCapacityDropdown = () => {
    setShowCapacityDropdown(!showCapacityDropdown);
  };

  // Function to close the dropdown when a capacity is selected
  const handleCapacitySelect = (capacity) => {
    setShowCapacityDropdown(false); 
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCapacityDropdown(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className={styles.capacityWrapper} ref={dropdownRef}>
      <FiltersButton
        label={t("space.persons")}
        isActive={!!filters.capacity}
        onClick={toggleShowCapacityDropdown}
      />
      {showCapacityDropdown && (
        <div className={styles.capacityDropdownWrapper}>
          <CapacityFilter onCapacitySelect={handleCapacitySelect} />
          <img src={SearchPeopleIcon} alt="number of people" />
        </div>
      )}
    </div>
  );
};

export default CapacityFilterButton;
